import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles.profile', {
        url: '/:profileId',
        redirectTo: 'user.profiles.profile.main',
        component: 'userProfile',
        resolve: {profile},
    });
}

/** @ngInject */
function profile($stateParams, profiles) {
    return profiles.find((profile) => profile.id === $stateParams.profileId);
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/profile.state.js